import { createValidator, ErrorObject, required } from 'util/validation'

import { isStatusValid } from '../../utils-consultaSeguimento'
import { CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta10Model } from './model-consultaSeguimentoPergunta10'
import {
  hasPergunta10ExemplosFalhouAnySim,
  hasPergunta10ExemplosPassouAnySim,
  isPergunta10ExemplosAllNao,
} from './utils-consultaSeguimentoPergunta10'

export const validatorConsultaSeguimentoPergunta10 = createValidator<ConsultaSeguimentoPergunta10Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_10_HEADER: required,
    PERGUNTA_10_EXEMPLOS: createValidator<ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']>({
      FALHOU: createValidator<NonNullable<ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']>['FALHOU']>({
        NAO_DA_RESPOSTA: required,
        PARECE_OUVIR_IGNORA: required,
        SO_RESPONDE_NA_FRENTE: required,
        SO_RESPONDE_SE_TOCADO: required,
      }),
      PASSOU: createValidator<NonNullable<ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']>['PASSOU']>({
        PROCURA: required,
        FALA_OU_EMITE_SOM: required,
        PARA_O_QUE_ESTA_FAZENDO: required,
      }),
    }),
  },
  (values: ConsultaSeguimentoPergunta10Model, errors: ErrorObject<ConsultaSeguimentoPergunta10Model>) => {
    const isPerguntaExemplosAllNao = isPergunta10ExemplosAllNao(values?.PERGUNTA_10_EXEMPLOS)
    const hasPerguntaExemplosPassouAnySim = hasPergunta10ExemplosPassouAnySim(values?.PERGUNTA_10_EXEMPLOS)
    const hasPerguntaExemplosFalhouAnySim = hasPergunta10ExemplosFalhouAnySim(values?.PERGUNTA_10_EXEMPLOS)

    if (isPerguntaExemplosAllNao) {
      errors.PERGUNTA_10_EXEMPLOS = CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE
    }

    if (hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
      errors.PERGUNTA_10_FREQUENCIA = required(values?.PERGUNTA_10_FREQUENCIA)
    }

    return errors
  }
)
